import React, { createContext, useContext } from "react";

export type IsWebviewContext = {
    isWebview: boolean;
};

const context = createContext<IsWebviewContext>({ isWebview: false });

export const IsWebviewProvider = context.Provider;
export const IsWebviewConsumer = context.Consumer;
export const useIsWebview = (): boolean => {
    const { isWebview = false } = useContext(context) || {};

    return isWebview;
};
